import { Col } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SearchUsers } from '../../../../components';
import { TopSection } from './components';

// Entry point for a fresh "send a shoutout" flow with no target picked yet.
// AddMobileShoutout only mounts this while data.entity/data.eventObject are
// both unset — picking a result here sets one of them, which is itself the
// "advance": the parent's render switches straight to ShoutoutDetails.
const SendShoutout = ({ data, setData }) => {
  const [selected, setSelected] = useState(0),
    { t } = useTranslation();

  function handlePickEntity(opt) {
    setData((prev) => ({ ...prev, entity: opt }));
  }

  return (
    <Col wid="100%" marg="8px 0 0" center between>
      <TopSection selected={selected} setSelected={setSelected} />

      {selected === 0 && (
        <SearchUsers
          title={t('common.team')}
          type="team"
          handleSelect={handlePickEntity}
          selected={data.entity?.name}
        />
      )}

      {selected === 1 && (
        <SearchUsers
          title={t('common.athlete')}
          type="athlete"
          handleSelect={handlePickEntity}
          selected={data.entity?.name}
        />
      )}
    </Col>
  );
};

export default SendShoutout;
